import React, {createContext, useEffect, useState} from "../_snowpack/pkg/react.js";
import {useDidMount} from "./hooks/util.js";
import HomePage from "./pages/HomePage.js";
const NotificationContext = createContext([null, () => {
}]);
const defaultSettings = {
  darkMode: false,
  amiiboType: "figure"
};
const SettingsContext = createContext([defaultSettings, () => {
}]);
const App = () => {
  const [notification, setNotification] = useState(null);
  const [settings, setSettings] = useState(defaultSettings);
  const didMount = useDidMount();
  useEffect(() => {
    const userSettings = localStorage.getItem("settings");
    if (userSettings) {
      setSettings(JSON.parse(userSettings));
    }
  }, []);
  useEffect(() => {
    if (didMount) {
      localStorage.setItem("settings", JSON.stringify(settings));
    }
  }, [settings]);
  return /* @__PURE__ */ React.createElement(SettingsContext.Provider, {
    value: [settings, setSettings]
  }, /* @__PURE__ */ React.createElement(NotificationContext.Provider, {
    value: [notification, setNotification]
  }, /* @__PURE__ */ React.createElement(HomePage, null)));
};
export default App;
export {NotificationContext, SettingsContext};
